export const reactionEmojis = [
  "❤️", // Heart
  "😂", // Laughing tears
  "😊", // Happy / Smiling
  "😍", // Love eyes
  "😡", // Angry
  "😢", // Crying
  "😮", // Shock / Wow
  "😎", // Cool
  "👍", // Thumbs up
  "👎", // Thumbs down
  "👏", // Clap
  "🙌", // Celebrate / Praise hands
  "🎉", // Party popper
  "🔥", // Fire
  "💯", // 100
  "🤔", // Thinking
  "😴", // Sleepy
  "🤯", // Mind blown
  "🙏", // Pray / Thanks
  "🥳", // Celebration face
];

export interface ReactionProperty {
  userId: string;
  reaction: string;
}

export interface ReactionProperties {
  smallScaleReactions: ReactionProperty[];
  commonReactionsCounters: {
    [reaction: string]: number;
  }[];
}
